import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import {observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import SamplePodcastItem from '../components/SamplePodcastItem';

const SAMPLE_PODCASTS_REQUEST = '/api/v1/podcasts';

@withRouter
@observer

class SamplePodcastsList extends Component {
  constructor() {
    super();
    this.state = {
      podcasts: [],
    }
  }

  componentDidMount() {
    new HttpClient().get(`${SAMPLE_PODCASTS_REQUEST}`).then(response => {
      const {podcasts} = response.body.data || {};
      this.setState({podcasts});
    });
  }

  render() {
    const {podcasts} = this.state;
    return (
      <section className="section topics">
        <div className="container-fluid">
          <div className="row justify-content-center list-title">
            <h3>Sample Podcasts</h3>
          </div>
          <div className="row">
            <div className="container">
              <div className="list-container" style={{columnCount: 1}}>
                {podcasts.map(podcast =>
                  <SamplePodcastItem
                    key={podcast.id}
                    podcast={podcast}
                  />
                )}
                {/* { topicsStore.letters.map(letter =>
                    <div key={letter} className="topic-block">
                      <div className="row">
                        <div className="topic-block-letter">
                          <span>{letter}</span>
                        </div>
                        <div className="same-letter-wrapper">

                          { topicsStore.topics[letter].map(topic =>
                              <SamplePodcastItem
                                key={topic.id}
                                topic={topic}
                              />
                            )
                          }
                        </div>
                      </div>
                    </div>
                  )
                } */}
              </div>
            </div>
          </div>
          <div style={{display: 'flex'}}>
            <Link
              to='/topics'
              className="btn blue rounded submit-btn"
              disabled={!this.state.agree}
              style={{margin: '0 auto'}}
            >
              VIEW ALL MODULES
            </Link>
          </div>
        </div>
      </section>
    )
  }
} 

export default SamplePodcastsList;


// WEBPACK FOOTER //
// ./src/modules/samplePodcasts/containers/SamplePodcastsList.js